// extracted by mini-css-extract-plugin
export var label = "_rq-0";
export var link = "_rq-1";